/**
 * Klaviyo Integration Module
 *
 * This module provides a complete Klaviyo integration for Next.js with:
 * - Server-side API client for profile management and list subscriptions
 * - Server actions for form submissions with validation
 * - Client-side utilities for event tracking and user identification
 * - Anonymous visitor tracking with automatic backfill (up to 14 days)
 * - TypeScript types for all API payloads and responses
 * - Automatic _kx attribution tracking (email click-through campaigns)
 *
 * Usage:
 * - Server-side: Use `subscribeToKlaviyoList()` action or `getKlaviyoClient()` for direct API calls
 * - Client-side: Use `klaviyoIdentify()`, `klaviyoTrack()`, `trackStartedCheckout()` for browser tracking
 * - Anonymous: Use `getAnonymousId()` + `trackAnonymousKlaviyoEvent()` for server-side anonymous tracking
 * - Hybrid (client → server): Use `trackKlaviyoEventFromClient()` for guaranteed server-side tracking with attribution
 *
 * Setup (Required):
 * Add <KlaviyoProvider /> to your root layout to enable attribution tracking
 */

export * from './types';
export * from './client';
export * from './actions';
export * from './utils';
export * from './useKlaviyoIdentity';
export * from './KlaviyoProvider';
